<template>
  <div class="tax-table-wrap tax-table-wrap-tax53" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>纳税调整项目明细表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" tabletype="2024033105">
        <thead>
          <tr>
            <td class="title01" rowspan="2" style="white-space: initial; width: 10px; padding: 0 5px">行次</td>
            <td class="title01" rowspan="2" width="45%">项目</td>
            <td class="title01">账载金额</td>
            <td class="title01">税收金额</td>
            <td class="title01">调增金额</td>
            <td class="title01">调减金额</td>
          </tr>
          <tr>
            <td class="title01">1</td>
            <td class="title01">2</td>
            <td class="title01">3</td>
            <td class="title01">4</td>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td class="title01">1</td>
            <td class="title01 td2">一、收入类调整项目（2+3+4+5+6+7+8+10+11）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v1x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v1x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">2</td>
            <td class="title01 td2">（一）视同销售收入（填写A105010）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2">{{ parseFloatNum(data.v2x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v2x3.value) }}</td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">3</td>
            <td class="title01 td2">（二）未按权责发生制原则确认的收入（填写A105020）</td>
            <td class="d1">{{ parseFloatNum(data.v3x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v3x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v3x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v3x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">4</td>
            <td class="title01 td2">（三）投资收益（填写A105030）</td>
            <td class="d1">{{ parseFloatNum(data.v4x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v4x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v4x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v4x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">5</td>
            <td class="title01 td2">（四）按权益法核算长期股权投资对初始投资成本调整确认收益</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3" style="text-align: center">--</td>
            <td class="d4"><el-input-number v-model.trim="data.v5x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">6</td>
            <td class="title01 td2">（五）交易性金融资产初始投资调整</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">7</td>
            <td class="title01 td2">（六）公允价值变动净损益</td>
            <td class="d1"><el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v7x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v7x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">8</td>
            <td class="title01 td2">（七）不征税收入</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v8x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v8x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">9</td>
            <td class="title01 td2">其中：专项用途财政性资金（填写A105040）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v9x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v9x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">10</td>
            <td class="title01 td2">（八）销售折扣、折让和退回</td>
            <td class="d1"><el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v10x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v10x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">11</td>
            <td class="title01 td2">（九）其他</td>
            <td class="d1"><el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v11x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v11x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">12</td>
            <td class="title01 td2">二、扣除类调整项目（13+14+15+16+17+18+19+20+21+22+23+24+26+27+28+29+30）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v12x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v12x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v12x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v12x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">{{ parseFloatNum(data.v12x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">13</td>
            <td class="title01 td2">（一）视同销售成本（填写A105010）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2">{{ parseFloatNum(data.v13x2.value) }}</td>
            <td class="d3" style="text-align: center">--</td>
            <td class="d4">{{ parseFloatNum(data.v13x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">14</td>
            <td class="title01 td2">（二）职工薪酬（填写A105050）</td>
            <td class="d1">
              <!-- 关联职工薪酬表13行 账载金额 -->
              <!-- 考题 -->
              <taxQue :data="data.v14x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v14x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v14x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v14x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 关联职工薪酬表13行 税收金额 -->
              <!-- 考题 -->
              <taxQue :data="data.v14x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v14x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v14x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v14x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v14x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v14x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v14x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v14x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v14x4" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v14x4.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v14x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v14x4.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">15</td>
            <td class="title01 td2">（三）业务招待费支出</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v15x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v15x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v15x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v15x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v15x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v15x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v15x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v15x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v15x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v15x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v15x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v15x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">16</td>
            <td class="title01 td2">（四）广告费和业务宣传费支出（填写A105060）</td>
            <td style="text-align: center">--</td>
            <td style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v16x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v16x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">17</td>
            <td class="title01 td2">（五）捐赠支出（填写A105070）</td>
            <td class="d1">
              <!-- 关联数据 -->
              <!-- 关联捐赠支出表11行-账载金额 -->
              <!-- 考题 -->
              <taxQue :data="data.v17x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v17x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v17x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v17x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 关联数据 -->
              <!-- 关联捐赠支出表11行-税收金额 -->
              <!-- 考题 -->
              <taxQue :data="data.v17x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v17x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v17x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v17x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3">{{ parseFloatNum(data.v17x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v17x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">18</td>
            <td class="title01 td2">（六）利息支出</td>
            <td class="d1"><el-input-number v-model.trim="data.v18x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v18x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v18x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v18x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">19</td>
            <td class="title01 td2">（七）罚金、罚款和被没收财务的损失</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v19x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v19x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v19x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v19x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v19x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v19x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v19x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v19x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">20</td>
            <td class="title01 td2">（八）税收滞纳金、加收利息</td>
            <td class="d1"><el-input-number v-model.trim="data.v20x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v20x3.value) }}</td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">21</td>
            <td class="title01 td2">（九）赞助支出</td>
            <td class="d1"><el-input-number v-model.trim="data.v21x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v21x3.value) }}</td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">22</td>
            <td class="title01 td2">（十）与未实现融资收益相关在当期确认的财务费用</td>
            <td class="d1"><el-input-number v-model.trim="data.v22x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v22x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v22x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v22x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">23</td>
            <td class="title01 td2">（十一）佣金和手续费支出</td>
            <td class="d1"><el-input-number v-model.trim="data.v23x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v23x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v23x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v23x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">24</td>
            <td class="title01 td2">（十二）不征税收入用于支出所形成的费用</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v24x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">25</td>
            <td class="title01 td2">其中：专项用途财政性资金用于支出所形成的费用（填写A105040）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v25x3.value) }}</td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">26</td>
            <td class="title01 td2">（十三）跨期扣除项目</td>
            <td class="d1"><el-input-number v-model.trim="data.v26x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v26x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v26x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v26x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">27</td>
            <td class="title01 td2">（十四）与取得收入无关的支出</td>
            <td class="d1"><el-input-number v-model.trim="data.v27x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v27x3.value) }}</td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">28</td>
            <td class="title01 td2">（十五）境外所得分摊的共同支出</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v28x3.value) }}</td>
            <td class="d4" style="text-align: center">--</td>
          </tr>

          <tr class="tr">
            <td class="title01">29</td>
            <td class="title01 td2">（十六）党组织工作经费</td>
            <td class="d1"><el-input-number v-model.trim="data.v29x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v29x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v29x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v29x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">30</td>
            <td class="title01 td2">（十七）其他</td>
            <td class="d1"><el-input-number v-model.trim="data.v30x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v30x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v30x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v30x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">31</td>
            <td class="title01 td2">三、资产类调整项目（32+33+34+35）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v31x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v31x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">32</td>
            <td class="title01 td2">（一）资产折旧、摊销（填写A105080）</td>
            <td class="d1">
              <!-- 关联数据 -->
              <!-- 关联资产折旧表41行-本年折旧 -->
              <!-- 考题 -->
              <taxQue :data="data.v32x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v32x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v32x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v32x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 关联数据 -->
              <!-- 关联资产折旧表41行-税收折旧 -->
              <!-- 考题 -->
              <taxQue :data="data.v32x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v32x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v32x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v32x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3">{{ parseFloatNum(data.v32x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v32x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">33</td>
            <td class="title01 td2">（二）资产减值准备金</td>
            <td class="d1"><el-input-number v-model.trim="data.v33x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v33x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v33x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">34</td>
            <td class="title01 td2">（三）资产损失（填写A105090）</td>
            <td class="d1">
              <!-- 关联数据 -->
              <!-- 资产损失税前扣除及纳税调整明细表 第29行 资产损失直接计入本年 -->
              <!-- 考题 -->
              <taxQue :data="data.v34x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v34x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v34x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v34x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 关联数据 -->
              <!-- 资产损失税前扣除及纳税调整明细表 第29行 资产损失的税收金额 -->
              <!-- 考题 -->
              <taxQue :data="data.v34x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v34x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v34x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v34x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              {{ parseFloatNum(data.v34x3.value) }}
            </td>
            <td class="d4">
              {{ parseFloatNum(data.v34x4.value) }}
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">35</td>
            <td class="title01 td2">（四）其他</td>
            <td class="d1"><el-input-number v-model.trim="data.v35x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v35x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v35x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v35x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">36</td>
            <td class="title01 td2">四、特殊事项调整项目（37+38+39+40+41+42+43）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v36x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v36x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">37</td>
            <td class="title01 td2">（一）企业重组及递延纳税事项（填写A105100）</td>
            <td class="d1">{{ parseFloatNum(data.v37x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v37x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v37x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v37x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">38</td>
            <td class="title01 td2">（二）政策性搬迁（填写A105110）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v38x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v38x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">39</td>
            <td class="title01 td2">（三）特殊行业准备金（39.1+39.2+39.3+39.4+39.5+39.6+39.7）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v39x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v39x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">39.1</td>
            <td class="title01 td2">1.保险公司保险保障基金</td>
            <td class="d1">{{ parseFloatNum(data.v39_1x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v39_1x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v39_1x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v39_1x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">39.2</td>
            <td class="title01 td2">2.保险公司准备金</td>
            <td class="d1">{{ parseFloatNum(data.v39_2x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v39_2x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v39_2x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v39_2x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">39.3</td>
            <td class="title01 td2">其中：已发生未报案未决赔款准备金</td>
            <td class="d1">{{ parseFloatNum(data.v39_3x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v39_3x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v39_3x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v39_3x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">39.4</td>
            <td class="title01 td2">3.证券行业准备金</td>
            <td class="d1">{{ parseFloatNum(data.v39_4x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v39_4x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v39_4x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v39_4x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">39.5</td>
            <td class="title01 td2">4.期货行业准备金</td>
            <td class="d1">{{ parseFloatNum(data.v39_5x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v39_5x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v39_5x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v39_5x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">39.6</td>
            <td class="title01 td2">5.中小企业融资（信用）担保机构准备金</td>
            <td class="d1">{{ parseFloatNum(data.v39_6x1.value) }}</td>
            <td class="d2">{{ parseFloatNum(data.v39_6x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v39_6x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v39_6x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">39.7</td>
            <td class="title01 td2">6.金融企业、小额贷款公司准备金（填写 A105120）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">{{ parseFloatNum(data.v39_7x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v39_7x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">40</td>
            <td class="title01 td2">（四）房地产开发企业特定业务计算的纳税调整额（填写A105010）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2">{{ parseFloatNum(data.v40x2.value) }}</td>
            <td class="d3">{{ parseFloatNum(data.v40x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v40x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">41</td>
            <td class="title01 td2">（五）合伙企业法人合伙人应分得的应纳税所得额</td>
            <td class="d1"><el-input-number v-model.trim="data.v41x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v41x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v41x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v41x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">42</td>
            <td class="title01 td2">（六）发行永续债利息支出</td>
            <td class="d1"><el-input-number v-model.trim="data.v42x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v42x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">{{ parseFloatNum(data.v42x3.value) }}</td>
            <td class="d4">{{ parseFloatNum(data.v42x4.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">43</td>
            <td class="title01 td2">（七）其他</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v43x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v43x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">44</td>
            <td class="title01 td2">五、特别纳税调整应税所得</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v44x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v44x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">45</td>
            <td class="title01 td2">六、其他</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3"><el-input-number v-model.trim="data.v45x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v45x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="title01">46</td>
            <td class="title01 td2">合计（1+12+31+36+44+45）</td>
            <td class="d1" style="text-align: center">--</td>
            <td class="d2" style="text-align: center">--</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v46x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v46x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v46x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v46x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">{{ parseFloatNum(data.v46x4.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-show="false">{{ data.v50x1.value }}</div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        for (let column = 1; column <= 4; column++) {
          // 行1=2+3+4+5+6+7+8+10+11
          let res1 = new Big(0);
          for (let row = 2; row <= 11; row++) {
            if (row != 9) {
              res1 = res1.plus(data.value[`v${row}x${column}`].value);
            }
          }
          data.value[`v1x${column}`].value = res1.round(2).toNumber();

          // 行12=13+14+15+16+17+18+19+20+21+22+23+24+26+27+28+29+30
          let res2 = new Big(0);
          for (let row = 13; row <= 30; row++) {
            if (row != 25) {
              res2 = res2.plus(data.value[`v${row}x${column}`].value);
            }
          }
          data.value[`v12x${column}`].value = res2.round(2).toNumber();

          // 行31=32+33+34+35
          let res3 = new Big(0);
          for (let row = 32; row <= 35; row++) {
            res3 = res3.plus(data.value[`v${row}x${column}`].value);
          }
          data.value[`v31x${column}`].value = res3.round(2).toNumber();

          // 行36=37+38+39+40+41+42+43
          let res4 = new Big(0);
          for (let row = 37; row <= 43; row++) {
            res4 = res4.plus(data.value[`v${row}x${column}`].value);
          }
          data.value[`v36x${column}`].value = res4.round(2).toNumber();

          // 行46=1+12+31+36+44+45
          let res5 = new Big(0);
          [1, 12, 31, 36, 44, 45].forEach((row) => {
            res5 = res5.plus(data.value[`v${row}x${column}`].value);
          });
          data.value[`v46x${column}`].value = res5.round(2).toNumber();
        }

        // 第一列减去第二列 取绝对值 大于等于零 填入第四列 小于零 填入第三列 另外一个填入0
        [7, 11, 41].forEach((row) => {
          let res = new Big(data.value[`v${row}x1`].value).minus(data.value[`v${row}x2`].value);
          if (res.gte(0)) {
            data.value[`v${row}x3`].value = 0;
            data.value[`v${row}x4`].value = res.abs().round(2).toNumber();
          } else {
            data.value[`v${row}x3`].value = res.abs().round(2).toNumber();
            data.value[`v${row}x4`].value = 0;
          }
        });

        // 第一列减去第二列 取绝对值 大于等于零 填入第三列 小于零 填入第四列 另外一个填入0
        [10, 14, 18, 22, 26, 29, 30, 32, 34, 35, 42].forEach((row) => {
          let res = new Big(data.value[`v${row}x1`].value).minus(data.value[`v${row}x2`].value);
          if (res.gte(0)) {
            data.value[`v${row}x3`].value = res.abs().round(2).toNumber();
            data.value[`v${row}x4`].value = 0;
          } else {
            data.value[`v${row}x3`].value = 0;
            data.value[`v${row}x4`].value = res.abs().round(2).toNumber();
          }
        });
        // 15行 2列=主表第一行数据*0.005与本表的第1列第15行数据*0.6作比较，谁小取谁的值，保留两位小数
        data.value.v15x2.value = Math.min(new Big(data.value.v15x1.value).times(0.6).round(2).toNumber(), new Big(data.value.v50x1.value).times(0.005).round(2).toNumber());
        // 15行 3列=1列-2列
        data.value.v15x3.value = new Big(data.value.v15x1.value).minus(data.value.v15x2.value).round(2).toNumber();
        // 19行 3列=1列
        data.value.v19x3.value = new Big(data.value.v19x1.value).round(2).toNumber();
        // 20行 3列=1列
        data.value.v20x3.value = new Big(data.value.v20x1.value).round(2).toNumber();
        // 21行 3列=1列
        data.value.v21x3.value = new Big(data.value.v21x1.value).round(2).toNumber();
        // 23行 3列=1列-2列
        data.value.v23x3.value = new Big(data.value.v23x1.value).minus(data.value.v23x2.value).round(2).toNumber();
        // 27行 3列=1列
        data.value.v27x3.value = new Big(data.value.v27x1.value).round(2).toNumber();
        // 33行 3列=1列
        data.value.v33x3.value = new Big(data.value.v33x1.value).round(2).toNumber();

        syncAnswer({
          mode,
          newVal,
          oldVal,
          data,
        });
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  table {
    tbody {
      tr {
        td {
          &:nth-of-type(2) {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4" tabletype="2024033105">
  <thead>
    <tr>
      <td class="title01" rowspan="2" style="white-space: initial; width: 10px; padding: 0 5px">行次</td>
      <td class="title01" rowspan="2" width="45%">项目</td>
      <td class="title01">账载金额</td>
      <td class="title01">税收金额</td>
      <td class="title01">调增金额</td>
      <td class="title01">调减金额</td>
    </tr>
    <tr>
      <td class="title01">1</td>
      <td class="title01">2</td>
      <td class="title01">3</td>
      <td class="title01">4</td>
    </tr>
  </thead>
  <tbody>
    <tr class="tr">
      <td class="title01">1</td>
      <td class="title01 td2">一、收入类调整项目（2+3+4+5+6+7+8+10+11）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j1" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j1" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">2</td>
      <td class="title01 td2">（一）视同销售收入（填写A105010）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j2" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="p2 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="p3 input1" daan="0.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">3</td>
      <td class="title01 td2">（二）未按权责发生制原则确认的收入（填写A105020）</td>
      <td class="d1"><input type="text" value="0" class="i1 j3 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j3 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">4</td>
      <td class="title01 td2">（三）投资收益（填写A105030）</td>
      <td class="d1"><input type="text" value="0" class="i1 j4 k4_1 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j4 k4_2 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">5</td>
      <td class="title01 td2">（四）按权益法核算长期股权投资对初始投资成本调整确认收益</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j5" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j5" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3" style="text-align: center">--<input type="text" value="0" class="i3" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">6</td>
      <td class="title01 td2">（五）交易性金融资产初始投资调整</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j6" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j6" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input2" daan="0.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">7</td>
      <td class="title01 td2">（六）公允价值变动净损益</td>
      <td class="d1"><input type="text" value="0" class="i1 j7 input2" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j7" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">8</td>
      <td class="title01 td2">（七）不征税收入</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j8" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j8" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input2" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">9</td>
      <td class="title01 td2">其中：专项用途财政性资金（填写A105040）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j9" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j9" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">10</td>
      <td class="title01 td2">（八）销售折扣、折让和退回</td>
      <td class="d1"><input type="text" value="0" class="i1 j10 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j10 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">11</td>
      <td class="title01 td2">（九）其他</td>
      <td class="d1"><input type="text" value="0" class="i1 j11 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j11 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">12</td>
      <td class="title01 td2">二、扣除类调整项目（13+14+15+16+17+18+19+20+21+22+23+24+26+27+28+29+30）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="j12&quot;" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="j12&quot;" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="j12 input1" daan="31433.02" /></td>
      <td class="d4"><input type="text" value="0" class="j12 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">13</td>
      <td class="title01 td2">（一）视同销售成本（填写A105010）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j13" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j13 input1" daan="0.00" /></td>
      <td class="d3" style="text-align: center">--<input type="text" value="0" class="i3 j13" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j13 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">14</td>
      <td class="title01 td2">（二）职工薪酬（填写A105050）</td>
      <td class="d1"><input type="text" readonly="readonly" value="0" class="i1 i14 j14 input1" daan="6592761.05" /></td>
      <td class="d2"><input type="text" readonly="readonly" value="0" class="i2 i15 j14 input1" daan="6573111.81" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j14 i16 input1" daan="19649.24" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j14 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">15</td>
      <td class="title01 td2">（三）业务招待费支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j15 input2" daan="16959.44" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j15 input2" daan="10175.66" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j15 input1" daan="6783.78" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4 j15" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">16</td>
      <td class="title01 td2">（四）广告费和业务宣传费支出（填写A105060）</td>
      <td style="text-align: center">--</td>
      <td style="text-align: center">--</td>
      <td class="d3"><input type="text" value="0" class="j16 k16_3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="j16 k16_4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">17</td>
      <td class="title01 td2">（五）捐赠支出（填写A105070）</td>
      <td class="d1"><input type="text" readonly="readonly" value="0" class="i1 i17 j17 input1" daan="20000.00" /></td>
      <td class="d2"><input type="text" readonly="readonly" value="0" class="i2 i18 j17 input1" daan="20000.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j17 i19 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j17 i22 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">18</td>
      <td class="title01 td2">（六）利息支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j18 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j18 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j18 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j18 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">19</td>
      <td class="title01 td2">（七）罚金、罚款和被没收财务的损失</td>
      <td class="d1"><input type="text" value="0" class="i1 j19 input2" daan="5000.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j19" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j19 input1" daan="5000.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4 j19" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">20</td>
      <td class="title01 td2">（八）税收滞纳金、加收利息</td>
      <td class="d1"><input type="text" value="0" class="i1 j20 input2" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j20" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j20 input1" daan="0.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4 j20" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">21</td>
      <td class="title01 td2">（九）赞助支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j21 input2" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j21" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j21 input1" daan="0.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4 j21" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">22</td>
      <td class="title01 td2">（十）与未实现融资收益相关在当期确认的财务费用</td>
      <td class="d1"><input type="text" value="0" class="i1 j22 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j22 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j22 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j22 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">23</td>
      <td class="title01 td2">（十一）佣金和手续费支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j23 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j23 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j23 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j23 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">24</td>
      <td class="title01 td2">（十二）不征税收入用于支出所形成的费用</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j24" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j24" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j24 input2" daan="0.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4 j24" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">25</td>
      <td class="title01 td2">其中：专项用途财政性资金用于支出所形成的费用（填写A105040）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j25" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j25" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j25 input1" daan="0.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4 j25" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">26</td>
      <td class="title01 td2">（十三）跨期扣除项目</td>
      <td class="d1"><input type="text" value="0" class="i1 j26 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j26 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j26 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j26 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">27</td>
      <td class="title01 td2">（十四）与取得收入无关的支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j27 input2" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j27" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j27 input1" daan="0.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4 j27" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">28</td>
      <td class="title01 td2">（十五）境外所得分摊的共同支出</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j28" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j28" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j28 input1" daan="0.00" /></td>
      <td class="d4" style="text-align: center">--<input type="text" value="0" class="i4 j28" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">29</td>
      <td class="title01 td2">（十六）党组织工作经费</td>
      <td class="d1"><input type="text" value="0" class="i1 j29 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j29 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j29 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j29 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">30</td>
      <td class="title01 td2">（十七）其他</td>
      <td class="d1"><input type="text" value="0" class="i1 j30 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j30 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j30 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j30 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">31</td>
      <td class="title01 td2">三、资产类调整项目（32+33+34+35）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j31" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="71926.32" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j31" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="71926.32" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j31 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j31 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">32</td>
      <td class="title01 td2">（一）资产折旧、摊销（填写A105080）</td>
      <td class="d1"><input type="text" readonly="readonly" value="0" class="i1 k32_1 j32 input1" daan="70211.77" /></td>
      <td class="d2"><input type="text" readonly="readonly" value="0" class="i2 k32_2 j32 input1" daan="70211.77" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j32 i35 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j32 i36 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">33</td>
      <td class="title01 td2">（二）资产减值准备金</td>
      <td class="d1"><input type="text" value="0" class="i1 j33 input2" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j33" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j33 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j33 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">34</td>
      <td class="title01 td2">（三）资产损失（填写A105090）</td>
      <td class="d1"><input type="text" readonly="readonly" value="0" class="i1 i33 j34 input1" daan="1714.55" /></td>
      <td class="d2"><input type="text" readonly="readonly" value="0" class="i2 i34 j34 input1" daan="1714.55" /></td>
      <td class="d3"><input type="text" readonly="readonly" value="0" class="i3 j34 i37 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" readonly="readonly" value="0" class="i4 j34 i38 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">35</td>
      <td class="title01 td2">（四）其他</td>
      <td class="d1"><input type="text" value="0" class="i1 j35 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j35 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j35 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j35 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">36</td>
      <td class="title01 td2">四、特殊事项调整项目（37+38+39+40+41+42+43）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j36" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j36" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j36 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j36 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">37</td>
      <td class="title01 td2">（一）企业重组及递延纳税事项（填写A105100）</td>
      <td class="d1"><input type="text" value="0" class="i1 j37 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j37 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j37 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j37 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">38</td>
      <td class="title01 td2">（二）政策性搬迁（填写A105110）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j38" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j38" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j38 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j38 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">39</td>
      <td class="title01 td2">（三）特殊行业准备金（39.1+39.2+39.3+39.4+39.5+39.6+39.7）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j39" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j39" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">39.1</td>
      <td class="title01 td2">1.保险公司保险保障基金</td>
      <td class="d1"><input type="text" value="0" class="i1 j39_1 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j39_1 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39_1 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39_1 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">39.2</td>
      <td class="title01 td2">2.保险公司准备金</td>
      <td class="d1"><input type="text" value="0" class="i1 j39_2 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j39_2 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39_2 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39_2 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">39.3</td>
      <td class="title01 td2">其中：已发生未报案未决赔款准备金</td>
      <td class="d1"><input type="text" value="0" class="i1 j39_3 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j39_3 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39_3 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39_3 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">39.4</td>
      <td class="title01 td2">3.证券行业准备金</td>
      <td class="d1"><input type="text" value="0" class="i1 j39_4 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j39_4 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39_4 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39_4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">39.5</td>
      <td class="title01 td2">4.期货行业准备金</td>
      <td class="d1"><input type="text" value="0" class="i1 j39_5 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j39_5 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39_5 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39_5 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">39.6</td>
      <td class="title01 td2">5.中小企业融资（信用）担保机构准备金</td>
      <td class="d1"><input type="text" value="0" class="i1 j39_6 input1" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j39_6 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39_6 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39_6 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">39.7</td>
      <td class="title01 td2">6.金融企业、小额贷款公司准备金（填写 A105120）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j39_7" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j39_7" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j39_7 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j39_7 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">40</td>
      <td class="title01 td2">（四）房地产开发企业特定业务计算的纳税调整额（填写A105010）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j40" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j40 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j40 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j40 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">41</td>
      <td class="title01 td2">（五）合伙企业法人合伙人应分得的应纳税所得额</td>
      <td class="d1"><input type="text" value="0" class="i1 j41 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j41 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j41 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j41 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="title01">42</td>
      <td class="title01 td2">（六）发行永续债利息支出</td>
      <td class="d1"><input type="text" value="0" class="i1 j42 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j42 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j42 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j42 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">43</td>
      <td class="title01 td2">（七）其他</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j43" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j43" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j43 input2" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j43 input2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">44</td>
      <td class="title01 td2">五、特别纳税调整应税所得</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j44" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j44" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j44 input2" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j44 input2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">45</td>
      <td class="title01 td2">六、其他</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j45" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j45" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j45 input2" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j45 input2" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">46</td>
      <td class="title01 td2">合计（1+12+31+36+44+45）</td>
      <td class="d1" style="text-align: center">--<input type="text" value="0" class="i1 j46" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="6706646.81" /></td>
      <td class="d2" style="text-align: center">--<input type="text" value="0" class="i2 j46" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="6675213.79" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j46 input1" daan="31433.02" /></td>
      <td class="d4"><input type="text" value="0" class="i4 j46 input1" daan="0.00" /></td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*none.*>/g, "");
  s = s.replace(/<input.*type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
